export const SSO_USER_SIGN_IN = "SSO_USER_SIGN_IN";
export const SSO_USER_SIGN_OUT = "SSO_USER_SIGN_OUT";